import { render } from "./LanguagesDataTable.vue?vue&type=template&id=fd197c52&ts=true"
import script from "./LanguagesDataTable.vue?vue&type=script&lang=ts"
export * from "./LanguagesDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__